const _ = require('underscore');
const React = require("react");
const createReactClass = require("create-react-class");
const form = require('../../deploynaut/js/Form.jsx');

let RemoveLetsEncryptDomainForm = createReactClass({
	render: function() {
		return (
			<form.Form
				ref="removeLEDomainForm"
				url={this.props.actionURL}
				securityID={this.props.model.SecurityID}
				buttonTitle="Remove domain"
				buttonSubmittingTitle="Removing"
				afterSuccess={this.props.afterSuccess}
				cancelButton={<button className="btn btn-link" onClick={this.props.cancelHandler}>Cancel</button>}
			>
				<p>
					Removing <strong>{this.props.domain.Name}</strong> from your Let's Encrypt certificate will cause
					your certificate to be updated without this domain name during the next renewal cycle.
				</p>
				<p>
					If you decide to re-add this domain name at a later date, you will need start over the CNAME
					verification process which may take up to 12 hours to complete.
				</p>
				<form.Hidden name='ID' value={this.props.domain.ID} />
			</form.Form>
		);
	}
});

module.exports = RemoveLetsEncryptDomainForm;
